import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-408a5d9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "user-menu menu menu-sub menu-sub-dropdown",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "user-menu__profile" }
const _hoisted_3 = { class: "user-menu__avatar" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "user-menu__identity" }
const _hoisted_6 = { class: "user-menu__name" }
const _hoisted_7 = {
  key: 0,
  class: "user-menu__role"
}
const _hoisted_8 = {
  key: 1,
  class: "user-menu__phone"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-menu__divider" }, null, -1))
const _hoisted_10 = { class: "user-menu__list" }
const _hoisted_11 = { class: "user-menu__item-icon user-menu__item-icon--primary" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "user-menu__item-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "user-menu__item-label" }, "Hồ sơ của tôi"),
  /*#__PURE__*/_createElementVNode("span", { class: "user-menu__item-hint" }, "Xem và cập nhật thông tin")
], -1))
const _hoisted_13 = { class: "user-menu__item-icon user-menu__item-icon--danger" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "user-menu__item-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "user-menu__item-label" }, "Đăng xuất"),
  /*#__PURE__*/_createElementVNode("span", { class: "user-menu__item-hint" }, "Thoát khỏi phiên làm việc")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.avatarSrc,
          alt: _ctx.displayName
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.displayName), 1),
        (_ctx.displayRole)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.displayRole), 1))
          : _createCommentVNode("", true),
        (_ctx.userDetail.phone)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.userDetail.phone), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_router_link, {
        to: "/quan-ly/tai-khoan/thong-tin",
        class: "user-menu__item"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_11, [
            _createVNode(_component_font_awesome_icon, { icon: _ctx.faUser }, null, 8, ["icon"])
          ]),
          _hoisted_12
        ]),
        _: 1
      }),
      _createElementVNode("button", {
        type: "button",
        class: "user-menu__item user-menu__item--danger",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args)))
      }, [
        _createElementVNode("span", _hoisted_13, [
          _createVNode(_component_font_awesome_icon, { icon: _ctx.faRightFromBracket }, null, 8, ["icon"])
        ]),
        _hoisted_14
      ])
    ])
  ]))
}